import {translate, settings} from '../../bootstrap/i18n';
import {CURRENCY_CODE, CURRENCY_MULTIPLIER, CURRENCY_SYMBOL} from '../view-constants/currency';
import {DISPLAYED_DATE_FORMAT, DISPLAYED_DATE_HM_FORMAT} from "../view-constants/date-time/formats";
import moment from "moment";

settings.setResource('en', Object.assign(
    require('../../bootstrap/i18n/resources/en.json'),
    require('./resources/en.json')
));

settings.setResource('vi', Object.assign(
    require('../../bootstrap/i18n/resources/vi.json'),
    require('./resources/vi.json')
));

settings.setDefaultLocale('en');

settings.setLocale(window.DATA &&  window.DATA.locale ? window.DATA.locale : 'vi');

settings.setCurrencyFormatter((amount, locale, style) => {
    if (amount === 0) {
        return translate('Free');
    }

    amount *= CURRENCY_MULTIPLIER;

    if (style === 'symbol') {
        return translate('::amount::symbol', {amount, symbol: CURRENCY_SYMBOL}, locale);
    }

    return translate('::amount ::unit', {amount, unit: CURRENCY_CODE}, locale);
});

settings.setDateFormatter((date, locale, style) => {
    if (style === 'dateTime') {
        return moment(date).format(DISPLAYED_DATE_HM_FORMAT);
    }
    return moment(date).format(DISPLAYED_DATE_FORMAT);
});

/**
 *
 * @param {string} id
 * @param {Object.<string,string|number|Array>|null?} params
 * @param {string?} locale
 * @return {string}
 */
function __(id, params, locale) {
    return translate(id, params, locale);
}

function getLocale() {
    return settings.getLocale();
}

export {
    getLocale,
};

export default __;
